/*  Local Development
 */
const usersServiceApi = 'https://users.api.suvo-services-stag.com/api/v1/';
const dataServiceApi = 'https://data.api.suvo-bi-staging.com/api/v1/';
const subscriptionServiceApi = 'https://subscriptions.api.suvo-bi-staging.com/api/v1/';
const mediaServiceApi = 'https://media.api.suvo-services.com/api/v1';
const mediaStaticAssets = 'https://suvo-services-staging-media.s3.eu-west-1.amazonaws.com/suvo_bi';
const canEditDashboards = false;
const filtersButtonTour = true;

/*  Exported Environment
 */
export const environment = {
  /** @deprecated Use active tenant's `primaryWebUrl`. */
  publicUrl: 'http://localhost:4200/',

  publicDomain: 'suvo-bi-staging.com',
  shopDomainSuffix: 'shops.suvo-bi-staging.com',
  usersServiceApi,
  dataServiceApi,
  mediaServiceApi,
  mediaStaticAssets,
  subscriptionServiceApi,
  title: 'IRJ BI',
  showRegisterDoBField: false,
  production: false,
  canEditDashboards,
  filtersButtonTour,
  tempTenantConfig: {
    showOrganisationFunctionality: false,
  },
  platformId: 'suvo_bi',
  firebaseAuthDomain: 'suvo-bi-users-staging.firebaseapp.com',
  firebaseApiKey: 'AIzaSyDuKI5PPzbLQzX65ewQQK4e9PY1y3eCV6I',
  useDevSubdomain: false,
};

export const suvoUsersClientLibConfig = {
  usersServiceApi,
  dataServiceApi,
  title: 'IRJ BI',
  showRegisterDoBField: false,
};
